// ROUTES
export const ROUTE_LIST = 'admin2.groups.list';
export const ROUTE_CREATE = 'admin2.groups.create';
export const ROUTE_UPDATE = 'admin2.groups.update';

// STORAGE KEYS
export const GROUPS_LIST_STORAGE_KEY = 'admin-groups-list';
export const GROUPS_LIST_VIEW_KEY = 'tv-admin-groups-list';

// DATA TYPES
export const GROUPS_TYPE_CE = 'CE';
export const GROUPS_TYPE_FACILITY = 'FACILITY';
export const GROUPS_TYPE_IDN = 'IDN';
export const GROUPS_TYPE_MAPPING = 'MAPPING';
export const GROUPS_TYPE_PHARMACY = 'PHARMACY';

export const GROUPS_STATUS_ACTIVE = 'ACTIVE';
export const GROUPS_STATUS_INACTIVE = 'INACTIVE';
